import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/services/global.service';
import { ConfirmModalComponent } from 'app/shared/confirmModal/confirmModal.component';

@Component({
  selector: 'app-support-categoies-quick-action',
  templateUrl: './support-categoies-quick-action.component.html',
  styles: []
})
export class SupportCategoiesQuickActionComponent implements OnInit {

  @Input() categories: any[] = [];

  categoryList: any[] = [];

  newCategory: any = {
    name: '',
    description: ''
  };

  editingCategoryId: number = null;

  nameError = '';
  descriptionError = '';

  @ViewChild('categoryNameInput') categoryNameInput: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    public global: GlobalService,
    public modalService: NgbModal,
  ) {}

  ngOnInit(): void {

    // Create separate copy so parent data is not changed
    // until user clicks Save/Add Categories.
    this.categoryList = (this.categories || []).map(
      category => ({
        ...category
      })
    );

  }

  /* =========================
     MODAL
     ========================= */

  close(): void {
    this.activeModal.dismiss();
  }

  saveCategories(): void {

    this.activeModal.close({
      success: true,
      categories: this.categoryList
    });

  }

  /* =========================
     VALIDATION
     ========================= */

  clearErrors(): void {
    this.nameError = '';
    this.descriptionError = '';
  }

  validateCategory(): boolean {

    this.clearErrors();

    const name = (
      this.newCategory.name || ''
    ).toString().trim();

    const description = (
      this.newCategory.description || ''
    ).toString().trim();

    if (!name) {

      this.nameError =
        'Category name is required.';

    } else if (name.length < 3) {

      this.nameError =
        'Category name must be at least 3 characters.';

    } else if (name.length > 50) {

      this.nameError =
        'Category name cannot exceed 50 characters.';

    }

    if (description.length > 200) {

      this.descriptionError =
        'Description cannot exceed 200 characters.';

    }

    return !this.nameError &&
      !this.descriptionError;
  }

  /* =========================
     ADD / UPDATE
     ========================= */

  addCategory(): void {

    if (!this.validateCategory()) {
      return;
    }

    const name = this.newCategory.name
      .toString()
      .trim();

    const description =
      (this.newCategory.description || '')
        .toString()
        .trim();

    /* =========================
       DUPLICATE CHECK
       ========================= */

    const duplicate = this.categoryList.some(
      category =>
        category.name.toLowerCase() ===
        name.toLowerCase() &&
        category.id !== this.editingCategoryId
    );

    if (duplicate) {

      this.nameError =
        'This category already exists.';

      return;
    }

    /* =========================
       UPDATE EXISTING
       ========================= */

    if (this.editingCategoryId !== null) {

      const category =
        this.categoryList.find(
          item =>
            item.id ===
            this.editingCategoryId
        );

      if (!category) {
        return;
      }

      category.name = name;
      category.description = description;

      // Keep modal open
      this.cancelEdit();

      return;
    }

    /* =========================
       ADD NEW CATEGORY
       ========================= */

    const newCategory = {

      id: this.getNextId(),

      name: name,

      description: description,

      ticketCount: 0,

      active: true,

      isNew: true

    };

    this.categoryList.push(newCategory);

    // Clear form
    this.newCategory = {
      name: '',
      description: ''
    };

    this.clearErrors();

    // IMPORTANT:
    // Do NOT close modal here.
  }

  getNextId(): number {

    if (!this.categoryList.length) {
      return 1;
    }

    const ids = this.categoryList.map(
      category =>
        Number(category.id) || 0
    );

    return Math.max.apply(null, ids) + 1;
  }

  /* =========================
     EDIT
     ========================= */

  editCategory(category: any): void {

    this.editingCategoryId =
      category.id;

    this.newCategory = {

      name: category.name,

      description:
        category.description || ''

    };

     setTimeout(() => {

    if (this.categoryNameInput) {

      this.categoryNameInput.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      this.categoryNameInput.nativeElement.focus();

    }

  }, 100);

    this.clearErrors();
  }

  cancelEdit(): void {

    this.editingCategoryId = null;

    this.newCategory = {
      name: '',
      description: ''
    };

    this.clearErrors();
  }

  /* =========================
     DELETE
     ========================= */

  deleteCategory(category: any): void {

  if (category.ticketCount > 0) {

    this.global.failureErrorModalcommon(
      'This category has tickets assigned to it. You cannot delete it.'
    );

    return;
  }

  const modalRef = this.modalService.open(
    ConfirmModalComponent,
    {
      centered: true
    }
  );

  modalRef.componentInstance.confirmValues = {
    modalId: 'deleteSupportCategory',
    title: 'Delete Category',
    cancelText: 'No',
    deleteText: 'Yes',
    message: 'Are you sure you want to delete this category?'
  };

  modalRef.result
    .then((result: any) => {

      // Only delete when user confirms
      if (result) {

        this.categoryList =
          this.categoryList.filter(
            item =>
              item.id !== category.id
          );

      }

    })
    .catch((error) => {

      // User closed/cancelled confirmation modal
      console.log('Delete cancelled');

    });

}

  /* =========================
     ENABLE / DISABLE
     ========================= */

  toggleCategory(category: any): void {

    category.active = !category.active;

    // IMPORTANT:
    // Do NOT close modal here.
  }

}